import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ImageModal from "../../../../components/imageModal";
import Plan from "../../../../components/cardButton";
import {
  PURCHASE_TYPE,
  PURCHASE_USED_KEY,
  PURCHASE_STEPS_TYPE
} from "../../../../constants/purchase";
const NewProjectDeniedModal = props => {
  const goToCreateProject = planId => {
    props.history.push({
      pathname: "/purchase",
      state: {
        [PURCHASE_USED_KEY.FORM_STEP]: PURCHASE_STEPS_TYPE.CHOOSE_PLAN,
        [PURCHASE_USED_KEY.PURCHASE_ACTION]: PURCHASE_TYPE.NEW,
        [PURCHASE_USED_KEY.PLAN_ID]: planId
      }
    });
    props.handleShow(false);
  };
  if (!props.status) {
    return null;
  } else {
    return (
      <ImageModal
        closeHandler={() => props.handleShow(false)}
        imageIcon="Premium_mapsa_icon.svg"
        title={props.title}
        description={props.description}
        rightButtons={[
          {
            type: "outline",
            borderless: true,
            onClick: () => {
              window.open("https://mapsa.ir/pricing/", "_blank");
              if (props.rejectOnClick) props.rejectOnClick();
            },
            title: "اطلاعات بیشتر"
          }
        ]}
        leftButtons={[
          {
            type: "ghost",
            borderless: false,
            onClick: () => {
              props.handleShow(false);
              props.rejectOnClick && props.rejectOnClick();
            },
            title: "انصراف"
          }
        ]}
      >
        {props.init.data.premium_prices.map(plan => {
          let description;
          if (plan.discount_percent > 0) {
            description = `با انتخاب ${plan.title} از ${plan.discount_percent}% تخفیف بهر‌مند شوید!`;
          }
          return (
            <Plan
              key={plan.id}
              rightTitle={`${plan.title}`}
              leftTitle={` <span>تومان</span> ${parseInt(
                (plan.user_price + plan.volume_price + plan.constant_price) / 10
              ).toLocaleString("fa")}`}
              description={description}
              onClick={() => goToCreateProject(plan.id)}
            />
          );
        })}
      </ImageModal>
    );
  }
};

const mapStateToProps = store => {
  return {
    init: store.Init
  };
};
export default connect(
  mapStateToProps,
  null
)(withRouter(NewProjectDeniedModal));
